import { render, staticRenderFns } from "./PersonnelRecordEdit.vue?vue&type=template&id=5bb436de"
import script from "./PersonnelRecordEdit.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports